<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 card_bg">
					<as-part-info-search-container ref="aspartInfoSearch" :scrId="scrId"></as-part-info-search-container>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<as-part-info-table-container
						ref="tableContainer"
						@Refresh="Refresh"
						:sendParam3="sendParam3"
						:sendParam="sendParam"
						@PopupOpen="PopupOpen"
						@OpenPopupPartNo="OpenPopupPartNo"
						@OpenGridOpPopup="OpenGridOpPopup"
						:scrId="scrId"
					></as-part-info-table-container>
					<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
				</sf-card>
			</div>
			<!-- 원인부품 팝업 -->
			<part-popup ref="partPopup" @SendPartData="sendData3" @Refresh="Refresh" :scrId="scrId" />
			<!--op코드 팝업-->
			<com-cd-popup ref="comCdPopup" :scrId="scrId" @SendData="sendData"></com-cd-popup>
			<!--엑셀 업로드 팝업창 영역 끝-->
			<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import PartPopup from '@qms/comm/commpopup/PartPopup/PartPopup.vue';
import { serviceComputed, serviceMethods } from '../store/helpers';
import ComCdPopup from '@/views/qms/comm/commpopup/ComCdPopup/ComCdPopup.vue';
import AsPartInfoSearchContainer from './Search/AsPartInfoSearchContainer.vue';
import AsPartInfoTableContainer from './Table/AsPartInfoTableContainer.vue';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {},
			faivorite: true,
			screen: {},
			sendParam3: {} //원인부품팝업
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	components: {
		AsPartInfoSearchContainer,
		AsPartInfoTableContainer,
		ExcelUploadModal,
		PartPopup,
		ComCdPopup
	},
	methods: {
		...serviceMethods,
		//popupOpen(param) {
		//this.$refs.popupView.open(param);
		//},
		OpenPopupPartNo(param) {
			this.$refs.partPopup.open(param); //.open(param);
		},
		OpenGridOpPopup(commCd) {
			this.$refs.comCdPopup.open(commCd); //.open(param);
		},
		Refresh() {
			this.$sf_toggleLoading(false);
			this.$refs.aspartInfoSearch.searchList();
		},
		sendData(param) {
			this.$refs.tableContainer.gridOpCdPopUp(param); // OP코드 팝업 DATA
			this.sendParam = param;
		},
		PopupOpen(param) {
			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		},
		sendData3(param) {
			this.$refs.tableContainer.gridParNoPopUp(param); //  부품조회 팝업 DATA
			this.sendParam3 = param;
		}
	},
	created() {
		this.$sf_toggleLoading(true);
		this.getCommCodes_({ key: 'opCdList', codeType: 'OP_CD' }); //OP코드
		this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' }); //PWA 여부
		this.$sf_toggleLoading(false);
	}
};
</script>

<style></style>
